import { render } from "./TheMyMbNameAndComment.vue?vue&type=template&id=f3ad0c94"
import script from "./TheMyMbNameAndComment.vue?vue&type=script&lang=js"
export * from "./TheMyMbNameAndComment.vue?vue&type=script&lang=js"
script.render = render

export default script